// ==========================================================
// TYPES DE GARANTIE
// ==========================================================

export const WARRANTY_PLAN_TYPES = {
  basic: "Basic",
  standard: "Standard",
  premium: "Premium",
  custom: "Custom",
};
